import { Component, Inject, OnInit } from '@angular/core';
import { distinctUntilChanged, skip, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SolarService } from 'src/app/services/cadastre-solaire/cadastre-solaire.service';
import { ProfileEnum } from 'src/app/models/Solar';

@Component({
    selector: 'cadastreSolaireThermal',
    templateUrl: './cadastre-solaire-thermal.template.html',
    standalone: false,
})
export class CadastreSolaireThermalComponent implements OnInit {
    private destroy$ = new Subject<void>();

    private modularity: any;
    public thermalStage: string = '';
    public activeTabId: number = 1;

    constructor(
        @Inject(LocalStorageService) private localStorageService: LocalStorageService,
        @Inject(SolarService) private solarService: SolarService,
    ) {}

    ngOnInit(): void {
        this.modularity = this.localStorageService.get('preferences').modularity.solar;

        const profile = this.solarService.getProfile();
        this.thermalStage =
            profile === ProfileEnum.INDIVIDUAL
                ? 'thermalBuildingDescriptionStage'
                : 'thermalSimulationStage';

        this._listenToEvents();
    }

    private _listenToEvents() {
        this.solarService.thermalStageObs$
            .pipe(skip(1), takeUntil(this.destroy$), distinctUntilChanged())
            .subscribe((thermalStage) => {
                if (thermalStage) {
                    this.thermalStage = thermalStage;
                }
            });
    }
}
